import PropTypes from 'prop-types'
import intl from 'react-intl-universal'

const LoadCompositionNumber = ({
  idLoadComposition,
  suggestionMessage
}) => (
  <div>
    <div className="negotiation-read-offer">
      <div className="negotiation-read-column">
        <span>{intl.get('menu.subMenuGeneral.loadComposition')}:</span>
        <span>{idLoadComposition}</span>
      </div>
    </div>
    <div className="negotiation-read-offer">
      <div className="negotiation-read-column">
        {suggestionMessage &&
          <>
            <span>{intl.get('stocks.timeline.justification')}</span>
            <span>{suggestionMessage}</span>
          </>
        }
      </div>
    </div>
  </div>
);

LoadCompositionNumber.propTypes = {
  idLoadComposition: PropTypes.number.isRequired,
  suggestionMessage: PropTypes.string
}

export default LoadCompositionNumber